import laurelLogo from 'assets/images/laurel-logo.png'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

const Footer = () => {
	const currentYear = new Date().getFullYear()

	return (
		<MDBox
			component="footer"
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			py={2}
			mt={4}
		>
			<MDBox display="flex" alignItems="center" justifyContent="center" mb={1}>
				<MDBox component="img" src={laurelLogo} alt="Brand" height="2rem" />
			</MDBox>

			<MDTypography variant="caption" color="text.secondary" align="center">
				&copy; {currentYear} All rights reserved. Powered by Laurel a product by Tazi Rides.
			</MDTypography>
		</MDBox>
	)
}

export default Footer
